/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019纷析云（杭州）科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月25日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import manba from 'manba';
import Decimal from 'decimal.js';
import {toClean} from "number-string";
import {isNumber} from "xe-utils";
import {confirm} from "heyui.ext";
import store from "@/store";

const FormatNum = function (f, digit = 2) {
  let m = Math.pow(10, digit);
  let des = f * m + 0.5;
  return parseInt(des, 10) / m;
};

const toFixed = function (num, s) {
  return Decimal(num).toFixed(s);
};

export default {
  install: (vue) => {
    vue.config.globalProperties.dxMoney = (number) => {
      if (!isNumber(number) || number === 0) {
        return "零元整";
      }

      let n = Math.abs(number);

      let unit = "仟佰拾亿仟佰拾万仟佰拾元角分", str = "";
      n += "00";
      let p = n.indexOf('.');
      if (p >= 0) {
        n = n.substring(0, p) + n.substr(p + 1, 2);
      }
      unit = unit.substring(unit.length - n.length);
      for (let i = 0; i < n.length; i++) {
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
      }

      return (number < 0 ? '负' : '') + str.replace(/零([仟佰拾角])/g, "零").replace(/(零)+/g, "零").replace(/零([万亿元])/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
    }

    vue.config.globalProperties.fqFormat = (n = '') => {
      if (!n) {
        return ''
      }
      if (n.indexOf('年') !== -1) {
        return n;
      }
      return manba(n).format("YYYY年MM期");
    };

    vue.config.globalProperties.dFormat = (n, format) => {
      if (!n) {
        return ''
      }
      return manba(n).format(format);
    };

    vue.config.globalProperties.moneyFormat = (n) => {
      if (!n) {
        return '0'
      }
      let num = Math.abs(n);
      if (num < 10000) {
        return n;
      } else if (num >= 10000 && num < 100000000) {
        return FormatNum(n / 10000) + "万";
      } else {
        return FormatNum(n / 100000000, 4) + "亿";
      }
    };

    vue.config.globalProperties.numFormat = (number, dft = '', maxPrecision = 2) => {
      if (!isNumber(number) || !number) {
        return dft || ''
      }
      return toClean(number, {maxPrecision: maxPrecision, minPrecision: 0});
    };

    vue.config.globalProperties.isChecked = (voucherDate) => {
      if (voucherDate) {
        const vd = manba(voucherDate);
        const checkout = store.getters.checkoutList.find((val) => val.checkYear === vd.year() && val.checkMonth === vd.month());
        if (checkout) {
          return checkout.status === 2;
        }
      }
      return true;
    };

    vue.config.globalProperties.SaCheckPermission = (value) => {
      const {roleInfo, authorities} = store.getters
      if (typeof value === 'string') {
        value = [value];
      }
      //账套管理员
      if (!roleInfo.astAdmin && !value.every(val => authorities.includes(val))) {
        return false;
      }
      return true;
    };

    vue.config.globalProperties.$Confirm = (content) => {
      return new Promise((resolve, reject) => {
        confirm({
          title: "操作提示",
          content,
          onConfirm: resolve,
          onCancel: reject
        })
      })
    };

    vue.config.globalProperties.FormatFileSize = (size, pointLength = 2, units = ['B', 'K', 'M', 'G', 'TB']) => {
      let unit;
      while ((unit = units.shift()) && size > 1024) {
        size = size / 1024;
      }
      return (unit === 'B' ? size : size.toFixed(pointLength)) + unit;
    }
  }
}
